import MyText from "./MyText"

export default function Button({ img = null, text, containerStyle={}, textStyle={}, imgStyle={},callback }) {
    return (
        <div style={{...styles.buttonContainer, ...containerStyle}} onClick={callback}>
            {img && <img src={img} alt="icon" style={{...styles.image, ...imgStyle}} />}
            <MyText style={{ fontSize: '1rem', fontFamily: 'Como-Bold', paddingLeft:20, paddingRight: 20,...textStyle }}>{text}</MyText>
        </div>
    )
}

const styles = {
    buttonContainer: {
        backgroundColor: '#e83465',
        padding: '15px 10px',
        borderRadius: '25px',
        color: "white",
        // width: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
    },
    image: {
        marginRight: '10px',
        height: "16px"
    }
}